import EventLatestHighlights from "./EventLatestHighlights";
export default EventLatestHighlights;
